import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SvgIcon from '../SvgIcon';

var QRcode = function QRcode(props) {
  return _jsxs(SvgIcon, __assign({}, props, {
    children: [_jsx("path", {
      d: "M13 13.5C13 13.2239 13.2239 13 13.5 13H14.5C14.7761 13 15 13.2239 15 13.5V14.5C15 14.7761 14.7761 15 14.5 15H13.5C13.2239 15 13 14.7761 13 14.5V13.5Z"
    }), _jsx("path", {
      d: "M18 13.5C18 13.2239 18.2239 13 18.5 13H19.5C19.7761 13 20 13.2239 20 13.5V14.5C20 14.7761 19.7761 15 19.5 15H18.5C18.2239 15 18 14.7761 18 14.5V13.5Z"
    }), _jsx("path", {
      d: "M15.5 16C15.5 15.7239 15.7239 15.5 16 15.5H17C17.2761 15.5 17.5 15.7239 17.5 16V17C17.5 17.2761 17.2761 17.5 17 17.5H16C15.7239 17.5 15.5 17.2761 15.5 17V16Z"
    }), _jsx("path", {
      d: "M13 18.5C13 18.2239 13.2239 18 13.5 18H14.5C14.7761 18 15 18.2239 15 18.5V19.5C15 19.7761 14.7761 20 14.5 20H13.5C13.2239 20 13 19.7761 13 19.5V18.5Z"
    }), _jsx("path", {
      d: "M18 18.5C18 18.2239 18.2239 18 18.5 18H19.5C19.7761 18 20 18.2239 20 18.5V19.5C20 19.7761 19.7761 20 19.5 20H18.5C18.2239 20 18 19.7761 18 19.5V18.5Z"
    }), _jsx("path", {
      d: "M6.5 7C6.5 6.72386 6.72386 6.5 7 6.5H8C8.27614 6.5 8.5 6.72386 8.5 7V8C8.5 8.27614 8.27614 8.5 8 8.5H7C6.72386 8.5 6.5 8.27614 6.5 8V7Z"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.6 5.6V9.4H9.4V5.6H5.6ZM5 4H10C10.5523 4 11 4.44772 11 5V10C11 10.5523 10.5523 11 10 11H5C4.44772 11 4 10.5523 4 10V5C4 4.44772 4.44772 4 5 4Z"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.6 5.6V9.4H18.4V5.6H14.6ZM14 4H19C19.5523 4 20 4.44772 20 5V10C20 10.5523 19.5523 11 19 11H14C13.4477 11 13 10.5523 13 10V5C13 4.44772 13.4477 4 14 4Z"
    }), _jsx("path", {
      d: "M15.5 7C15.5 6.72386 15.7239 6.5 16 6.5H17C17.2761 6.5 17.5 6.72386 17.5 7V8C17.5 8.27614 17.2761 8.5 17 8.5H16C15.7239 8.5 15.5 8.27614 15.5 8V7Z"
    }), _jsx("path", {
      d: "M7 15.5C6.72386 15.5 6.5 15.7239 6.5 16V17C6.5 17.2761 6.72386 17.5 7 17.5H8C8.27614 17.5 8.5 17.2761 8.5 17V16C8.5 15.7239 8.27614 15.5 8 15.5H7Z"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 13H5C4.44772 13 4 13.4477 4 14V19C4 19.5523 4.44772 20 5 20H10C10.5523 20 11 19.5523 11 19V14C11 13.4477 10.5523 13 10 13ZM5.6 18.4V14.6H9.4V18.4H5.6Z"
    })]
  }));
};

export default QRcode;